import React, { useCallback } from 'react';
import { RedirectBasedPayment } from '../common/GenericPayment/RedirectBasedPayment';

interface XpressBillPayFormProps {
  loading: boolean;
  onPay: () => Promise<{ url: string }>;
  permitIdentifier: string;
  totalDue: number;
  error?: string;
}

export const XpressBillPayForm = ({
  loading,
  onPay,
  permitIdentifier,
  totalDue,
  error,
}: XpressBillPayFormProps) => {
  const handleClickCallback = useCallback(async () => {
    const { url } = await onPay();

    const sURLParams = new URLSearchParams();

    // This is from the Single Permit view
    sURLParams.set('id', permitIdentifier);

    const windowUrl = new URL(`${url}?${sURLParams}`);

    return { url: windowUrl };
  }, [permitIdentifier, onPay]);

  return (
    <RedirectBasedPayment
      dataTestId="xpress-bill-pay-form-component"
      error={error}
      loading={loading}
      onClickCallback={handleClickCallback}
      totalDue={totalDue}
      launchWindow={true}
    >
      The button below will take you to the Xpress Bill Pay system to make your
      payment. A service charge will be added if paying with a credit card.
    </RedirectBasedPayment>
  );
};
